import {createRouter, createWebHistory} from 'vue-router'
import NotFound from '../views/misc/NotFound.vue'
import Login from "../views/Login.vue";
import MainLayout from "../views/MainLayout.vue";
import {MOTHER_MODULES, TOKEN} from "@/constants";
import {useModuleStatesStore} from "@/stores/useModuleStatesStore";
import {AlertConfigurations} from "@/service/alerts.service";
import {logoutUser} from "@/request";

let condition = true
function checkUserAccess(module, submodule = null, action = null) {
  let headers = JSON.parse(localStorage.getItem('header')) ?? []
  let modules = JSON.parse(localStorage.getItem('submodules')) ?? []

  if(submodule === null) {
    if(headers.includes(module)) return true
    return false
  }

  if(Object.keys(modules).length < 1) return
  if(!modules[module][submodule]) return false
  if(modules[module][submodule].includes(action) && action !== null) {
    return true
  }
  return false
}

function redirectToAccessibleModule(){
  let module = null
  let headers = JSON.parse(localStorage.getItem('header')) ?? []
  for(const key of Object.keys(MOTHER_MODULES)) {
    if(headers.includes(key)) {
      if(key === 'branch_liquidation') module = 'branchLiquidation'
      else {
        module = key
        break
      }
    }
  }

  return module
}

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '',
    redirect: {name: 'login'},
    component: MainLayout,
    meta: {requiresAuth: true},
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('../views/Filler.vue'),
        meta: {requiresAccess: true, title: 'Dashboard'},
        redirect: {name: 'quickButtons'},
        children: [
          {
            path: 'quick-buttons',
            name: 'quickButtons',
            component: () => import('../views/dashboard/QuickButtonsPage.vue')
          },
          {
            path: 'transaction-widgets',
            name: 'transactionWidgets',
            component: () => import('../views/dashboard/TransactionWidgets.vue')
          },
          {
            path: 'quotation-sample',
            name: 'QuotationSample',
            component: () => import('../views/dashboard/QuotationSample.vue')
          }
        ]
      },
      {
        path: '/transactions',
        name: 'transactionsFiller',
        meta: {requiresAccess: true},
        component: () => import('../views/Filler.vue'),
        children: [
          {
            path: '/transactions',
            name: 'transactions',
            redirect: {name: 'journalList'},
            component: () => import('../views/transactions/TransactionsPage.vue'),
          },
          {
            path: 'receivable',
            name: 'receivable',
            redirect: {name: 'receivableBilling'},
            component: () => import('../views/Filler.vue'),
            children: [
              {
                path: 'billing',
                name: 'receivableBilling',
                redirect: to => ({name: "receivableBillingList"}),
                children: [
                  {
                    path: "",
                    name: "receivableBillingList",
                    component: () => import("@/views/transactions/receivable/BillingList.vue")
                  },
                  {
                    path: ":id",
                    name: "receivableBillingDetails",
                    props: true,
                    beforeEnter(to, from, next){
                      condition = checkUserAccess('transactions', 'billing', 'view')
                      if(!condition) next({name: 'Page404'})
                      else next()
                    },
                    component: () => import("@/views/transactions/receivable/BillingDetails.vue")
                  },
                  {
                    path: "new",
                    name: "receivableNewBilling",
                    beforeEnter(to, from, next){
                      condition = checkUserAccess('transactions', 'billing', 'create') && checkUserAccess('transactions', 'billing', 'view')
                      if(!condition) next({name: 'Page404'})
                      else next()
                    },
                    props: true,
                    component: () => import("@/views/transactions/receivable/NewBilling.vue")
                  }
                ]
              },
              {
                path: 'collection',
                name: 'receivableCollection',
                redirect: to => ({name: "receivableCollectionList"}),
                children: [
                  {
                    path: "",
                    name: "receivableCollectionList",
                    component: () => import("@/views/transactions/receivable/CollectionList.vue")
                  },
                  {
                    path: ":id",
                    name: "receivableCollectionDetails",
                    props: true,
                    component: () => import("@/views/transactions/receivable/CollectionDetails.vue")
                  },
                  {
                    path: "new",
                    name: "receivableNewCollection",
                    props: true,
                    component: () => import("@/views/transactions/receivable/NewCollection.vue")
                  }
                ]
              },
              {
                path: 'sales-receipt',
                name: 'salesReceipt',
                redirect: {name: 'salesReceiptList'},
                component: () => import('@/views/Filler.vue'),
                children: [
                  {
                    path: '',
                    name: 'salesReceiptList',
                    props: {header: 'Sales Receipt'},
                    component: () => import('@/views/transactions/SalesList.vue')
                  },
                  {
                    path: 'create',
                    name: 'salesReceiptForm',
                    props: {header: 'Sales Receipt'},
                    component: () => import('@/views/transactions/SalesForm.vue')
                  }
                ]
              },
            ]
          },
          {
            path: 'payable',
            name: 'payable',
            redirect: {name: 'quotations'},
            component: () => import('@/views/Filler.vue'),
            children:[
              {
                path: 'purchase',
                name: 'payablePurchases',
                redirect: {name: 'payablePurchasesList'},
                component: () => import('@/views/Filler.vue'),
                children: [
                  {
                    path: '',
                    name: 'payablePurchasesList',
                    component: () => import('@/views/transactions/payable/PurchaseList.vue')
                  },
                  {
                    path: 'new',
                    name: 'payableNewPurchase',
                    component: () => import('@/views/transactions/payable/PurchaseList.vue')
                  },
                ]
              },
              {
                path: 'payment',
                name: 'payablePayment',
                redirect: {name: 'payablePaymentList'},
                component: () => import('@/views/Filler.vue'),
                children: [
                  {
                    path: '',
                    name: 'payablePaymentList',
                    component: () => import('@/views/transactions/payable/PaymentList.vue')
                  },
                  {
                    path: 'new',
                    name: 'payableNewPayment',
                    component: () => import('@/views/transactions/payable/PaymentList.vue')
                  },
                ]
              },
              {
                path: 'requisitions',
                name: 'requisitions',
                redirect: {name: 'requisitionList'},
                props: {header: 'Requisitions'},
                component: () => import('../views/Filler.vue'),
                children: [
                  {
                    path: '',
                    name: 'requisitionList',
                    component: () => import('@/views/transactions/Requisitions.vue')
                  },
                  {
                    path: ":transNo",
                    name: "requisitionForm",
                    props: true,
                    component: () => import("@/views/transactions/PurchasesFormList.vue")
                  }
                ]
              },
              {
                path: 'purchase-invoice',
                name: 'purchaseInvoice',
                props: {header: 'Purchase Invoice'},
                redirect: {name: 'purchaseInvoiceList'},
                component: () => import('../views/Filler.vue'),
                children: [
                  {
                    path: '',
                    name: 'purchaseInvoiceList',
                    component: () => import('@/views/transactions/PurchaseInvoice.vue')
                  },
                  {
                    path: ":transNo",
                    name: "purchaseInvoiceForm",
                    props: true,
                    component: () => import("@/views/transactions/PurchasesFormList.vue")
                  }
                ]
              },
              {
                path: 'purchase-order',
                name: 'purchaseOrder',
                props: {header: 'Purchase Order'},
                redirect: {name: 'purchaseOrderList'},
                component: () => import('../views/Filler.vue'),
                // children: [
                //   {
                //     path: '',
                //     name: 'purchaseOrderList',
                //     component: () => import('@/views/transactions/rfp/RequestForPaymentList.vue')
                //   },
                //   {
                //     path: ":transNo",
                //     name: "purchaseOrderForm",
                //     props: true,
                //     component: () => import("@/views/transactions/rfp/RequestForPaymentList.vue")
                //   }
                // ]
              }
            ]
          },
          {
            path: 'banks',
            name: 'banks',
            redirect: {name: 'bankDepositList'},
            component: () => import('@/views/Filler.vue'),
            children:[
              {
                path: 'deposits',
                name: 'bankDeposits',
                redirect: {name: 'bankDepositList'},
                component: () => import('@/views/Filler.vue'),
                children: [
                  {
                    path: '',
                    name: 'bankDepositList',
                    component: () => import('@/views/transactions/banks/DepositList.vue')
                  },
                  {
                    path: 'new',
                    name: 'bankNewDeposit',
                    component: () => import('@/views/transactions/payable/PurchaseList.vue')
                  },
                ]
              },
              {
                path: 'withdrawals',
                name: 'bankWithdrawals',
                redirect: {name: 'bankWithdrawalList'},
                component: () => import('@/views/Filler.vue'),
                children: [
                  {
                    path: '',
                    name: 'bankWithdrawalList',
                    component: () => import('@/views/transactions/banks/WithdrawalList.vue')
                  },
                  {
                    path: 'new',
                    name: 'bankNewWithdrawal',
                    component: () => import('@/views/transactions/payable/PurchaseList.vue')
                  },
                ]
              },
              {
                path: 'reconciliation',
                name: 'bankReconciliation',
                redirect: {name: 'bankReconciliationList'},
                component: () => import('@/views/Filler.vue'),
                children: [
                  {
                    path: '',
                    name: 'bankReconciliationList',
                    component: () => import('@/views/transactions/banks/ReconciliationList.vue')
                  },
                  {
                    path: 'new',
                    name: 'bankNewReconciliation',
                    component: () => import('@/views/transactions/payable/PurchaseList.vue')
                  },
                ]
              },
            ]
          },
          {
            path: 'sales',
            name: 'sales',
            redirect: {name: 'billingInvoice'},
            component: () => import('../views/Filler.vue'),
            children: [
              {
                path: 'billing-invoice',
                name: 'billingInvoice',
                redirect: {name: 'billingInvoiceList'},
                component: () => import('@/views/Filler.vue'),
                children: [
                  {
                    path: '',
                    name: 'billingInvoiceList',
                    props: {header: 'Billing Invoice'},
                    component: () => import('@/views/transactions/SalesList.vue')
                  },
                  {
                    path: 'create',
                    name: 'billingInvoiceForm',
                    props: {header: 'Billing Invoice '},
                    component: () => import('@/views/transactions/SalesForm.vue')
                  }
                ]
              },
              {
                path: 'sales-receipt',
                name: 'salesReceipt',
                redirect: {name: 'salesReceiptList'},
                component: () => import('@/views/Filler.vue'),
                children: [
                  {
                    path: '',
                    name: 'salesReceiptList',
                    props: {header: 'Sales Receipt'},
                    component: () => import('@/views/transactions/SalesList.vue')
                  },
                  {
                    path: 'create',
                    name: 'salesReceiptForm',
                    props: {header: 'Sales Receipt'},
                    component: () => import('@/views/transactions/SalesForm.vue')
                  }
                ]
              },
            ]
          },
          {
            path: 'purchases',
            name: 'purchases',
            redirect: {name: 'quotations'},
            component: () => import('@/views/Filler.vue'),
            children:[
              {
                path: 'quotations',
                name: 'quotations',
                props: {header: 'Quotations'},
                redirect: {name: 'quotationList'},
                component: () => import('@/views/Filler.vue'),
                children: [
                  {
                    path: '',
                    name: 'quotationList',
                    component: () => import('@/views/transactions/Quotations.vue')
                  },
                  {
                    path: ":transNo",
                    name: "quotationForm",
                    props: true,
                    component: () => import("@/views/transactions/PurchasesFormList.vue")
                  }
                ]
              },
              {
                path: 'requisitions',
                name: 'requisitions',
                redirect: {name: 'requisitionList'},
                props: {header: 'Requisitions'},
                component: () => import('../views/Filler.vue'),
                children: [
                  {
                    path: '',
                    name: 'requisitionList',
                    component: () => import('@/views/transactions/Requisitions.vue')
                  },
                  {
                    path: ":transNo",
                    name: "requisitionForm",
                    props: true,
                    component: () => import("@/views/transactions/PurchasesFormList.vue")
                  }
                ]
              },
              {
                path: 'purchase-invoice',
                name: 'purchaseInvoice',
                props: {header: 'Purchase Invoice'},
                redirect: {name: 'purchaseInvoiceList'},
                component: () => import('../views/Filler.vue'),
                children: [
                  {
                    path: '',
                    name: 'purchaseInvoiceList',
                    component: () => import('@/views/transactions/PurchaseInvoice.vue')
                  },
                  {
                    path: ":transNo",
                    name: "purchaseInvoiceForm",
                    props: true,
                    component: () => import("@/views/transactions/PurchasesFormList.vue")
                  }
                ]
              },
              {
                path: 'purchase-order',
                name: 'purchaseOrder',
                props: {header: 'Purchase Order'},
                redirect: {name: 'purchaseOrderList'},
                component: () => import('../views/Filler.vue'),
                // children: [
                //   {
                //     path: '',
                //     name: 'purchaseOrderList',
                //     component: () => import('@/views/transactions/rfp/RequestForPaymentList.vue')
                //   },
                //   {
                //     path: "new",
                //     name: "purchaseOrderForm",
                //     component: () => import("@/views/transactions/rfp/NewRequestForPayment.vue")
                //   }
                // ]
              }
            ]
          },
          {
            path: 'disbursement',
            name: 'disbursement',
            meta: {title: 'Disbursement Voucher'},
            redirect: {name: 'disbursementList'},
            component: () => import('@/views/Filler.vue'),
            children:[
              {
                path: '',
                name: 'disbursementList',
                component: () => import("@/views/transactions/automated_disbursement/AutomatedDisbursementList.vue"),
              },
              {
                path: 'new',
                name: 'disbursementNew',
                meta: {title: 'New Disbursement'},
                beforeEnter(to, from, next){
                  condition = checkUserAccess('transactions', 'disbursement_voucher', 'create') && checkUserAccess('transactions', 'disbursement_voucher', 'view')
                  if(!condition) next({name: 'Page404'})
                  else next()
                },
                component: () => import("@/views/transactions/automated_disbursement/NewAutomatedDisbursement.vue"),
              },
              {
                path: ':code',
                name: 'disbursementDetails',
                props: true,
                meta: {title: 'Modify Disbursement'},
                beforeEnter(to, from, next){
                  condition = checkUserAccess('transactions', 'disbursement_voucher', 'view')
                  if(!condition) next({name: 'Page404'})
                  else next()
                },
                component: () => import("@/views/transactions/automated_disbursement/UpdateAutomatedDisbursement.vue"),
              },
            ]
          },
          {
            path: 'receipts',
            name: 'receipts',
            redirect: {name: 'receiptList'},
            meta: {title: 'Receipt Voucher'},
            component: () => import('@/views/Filler.vue'),
            children:[
              {
                path: '',
                name: 'receiptList',
                component: () => import("@/views/transactions/vouchers/ReceiptList.vue"),
              },
              {
                path: 'new',
                name: 'receiptNew',
                meta: {title: 'New Receipt'},
                beforeEnter(to, from, next){
                  condition = checkUserAccess('transactions', 'receipt_voucher', 'create') && checkUserAccess('transactions', 'receipt_voucher', 'view')
                  if(!condition) next({name: 'Page404'})
                  else next()
                },
                component: () => import("@/views/transactions/updated_vouchers/NewReceiptVoucher.vue"),
              },
              {
                path: ':code',
                name: 'receiptDetails',
                props: true,
                meta: {title: 'Modify Receipt'},
                beforeEnter(to, from, next){
                  condition = checkUserAccess('transactions', 'receipt_voucher', 'view')
                  if(!condition) next({name: 'Page404'})
                  else next()
                },
                component: () => import("@/views/transactions/updated_vouchers/UpdateReceiptVoucher.vue"),
              },
            ]
          },
          {
            path: 'journals',
            name: 'journals',
            meta: {title: 'Journal Voucher'},
            redirect: {name: 'journalList'},
            component: () => import('@/views/Filler.vue'),
            children:[
              {
                path: '',
                name: 'journalList',
                component: () => import("@/views/transactions/vouchers/JournalList.vue"),
              },
              {
                path: 'new',
                name: 'journalNew',
                meta: {title: 'New Journal'},
                beforeEnter(to, from, next){
                  condition = checkUserAccess('transactions', 'journal_voucher', 'create') && checkUserAccess('transactions', 'journal_voucher', 'view')
                  if(!condition) next({name: 'Page404'})
                  else next()
                },
                component: () => import("@/views/transactions/vouchers/JournalVoucher.vue"),
              },
              {
                path: ':code',
                name: 'journalDetails',
                props: true,
                meta: {title: 'Modify Journal'},
                beforeEnter(to, from, next){
                  condition = checkUserAccess('transactions', 'journal_voucher', 'view')
                  if(!condition) next({name: 'Page404'})
                  else next()
                },
                component: () => import("@/views/transactions/vouchers/JournalVoucherDetails.vue"),
              },
            ]
          },
          {
            path: 'accounts-receivable',
            name: 'accountsReceivableTransaction',
            redirect: {name: 'accountsReceivableTransactionList'},
            meta: {title: 'Accounts Receivable'},
            component: () => import('@/views/Filler.vue'),
            children:[
              {
                path: '',
                name: 'accountsReceivableTransactionList',
                component: () => import("@/views/transactions/payable_receivable/AccountsReceivableList.vue"),
              },
              {
                path: 'manual/new',
                name: 'accountsReceivableNewTransaction',
                meta: {title: 'New Receivable'},
                beforeEnter(to, from, next){
                  condition = checkUserAccess('transactions', 'receivable', 'create') && checkUserAccess('transactions', 'receivable', 'view')
                  if(!condition) next({name: 'Page404'})
                  else next()
                },
                component: () => import("@/views/transactions/payable_receivable/AccountsReceivable.vue"),
              },
              {
                path: 'manual/:code',
                name: 'accountsReceivableTransactionDetails',
                props: true,
                meta: {title: 'Modify Receivable'},
                beforeEnter(to, from, next){
                  condition = checkUserAccess('transactions', 'receivable', 'view')
                  if(!condition) next({name: 'Page404'})
                  else next()
                },
                component: () => import("@/views/transactions/payable_receivable/AccountsReceivableDetails.vue"),
              },
              {
                path: 'manual/credit-note/new',
                name: 'accountsReceivableNewCreditNote',
                meta: {title: 'New Credit Note'},
                beforeEnter(to, from, next){
                  condition = checkUserAccess('transactions', 'receivable', 'create') && checkUserAccess('transactions', 'receivable', 'view')
                  if(!condition) next({name: 'Page404'})
                  else next()
                },
                component: () => import("@/components/credit_note/receivable/ReceivableNote.vue"),
              },
              {
                path: 'manual/credit-note/:code',
                name: 'accountsCreditNoteTransactionDetails',
                props: true,
                meta: {title: 'Modify Credit Note'},
                beforeEnter(to, from, next){
                  condition = checkUserAccess('transactions', 'receivable', 'view')
                  if(!condition) next({name: 'Page404'})
                  else next()
                },
                component: () => import("@/components/credit_note/receivable/ReceivableNoteDetails.vue"),
              },
                /**
              {
                path: 'new',
                name: 'newAccountsReceivableWithCalculation',
                meta: {title: 'New Receivable'},
                beforeEnter(to, from, next){
                  condition = checkUserAccess('transactions', 'receivable', 'create') && checkUserAccess('transactions', 'receivable', 'view')
                  if(!condition) next({name: 'Page404'})
                  else next()
                },
                component: () => import("@/views/transactions/payable_receivable/NewAccountsReceivableWithCalculations.vue"),
              },
                  **/
            ]
          },
          {
            path: 'accounts-payable',
            name: 'accountsPayableTransaction',
            redirect: {name: 'accountsPayableTransactionList'},
            meta: {title: 'Accounts Payable'},
            component: () => import('@/views/Filler.vue'),
            children:[
              {
                path: '',
                name: 'accountsPayableTransactionList',
                component: () => import("@/views/transactions/payable_receivable/AccountsPayableList.vue"),
              },
              {
                path: 'manual/new',
                name: 'accountsPayableNewTransaction',
                meta: {title: 'New Payable'},
                beforeEnter(to, from, next){
                  condition = checkUserAccess('transactions', 'payable', 'create') && checkUserAccess('transactions', 'payable', 'view')
                  if(!condition) next({name: 'Page404'})
                  else next()
                },
                component: () => import("@/views/transactions/payable_receivable/AccountsPayable.vue"),
              },
              {
                path: 'manual/debit-note/new',
                name: 'accountsPayableNewDebitNote',
                meta: {title: 'New Debit Note'},
                beforeEnter(to, from, next){
                  condition = checkUserAccess('transactions', 'payable', 'create') && checkUserAccess('transactions', 'payable', 'view')
                  if(!condition) next({name: 'Page404'})
                  else next()
                },
                component: () => import("@/components/credit_note/payables/PayableNote.vue"),
              },
              {
                path: 'manual/:code',
                name: 'accountsNewTransactionDetails',
                props: true,
                meta: {title: 'Modify Payable'},
                beforeEnter(to, from, next){
                  condition = checkUserAccess('transactions', 'payable', 'view')
                  if(!condition) next({name: 'Page404'})
                  else next()
                },
                component: () => import("@/views/transactions/payable_receivable/AccountsPayableDetails.vue"),
              },
              {
                path: 'manual/debit-note/:code',
                name: 'accountsDebitNoteTransactionDetails',
                props: true,
                meta: {title: 'Modify Debit Note'},
                beforeEnter(to, from, next){
                  condition = checkUserAccess('transactions', 'payable', 'view')
                  if(!condition) next({name: 'Page404'})
                  else next()
                },
                component: () => import("@/components/credit_note/payables/PayableNoteDetails.vue"),
              },
                // {
                //     path: ':code',
                //     name: 'accountsPayableWithCalculation',
                //     meta: {
                //         title: (route) => {
                //             if(route.params.code === 'new') return 'New Payable'
                //             return 'Modify Payable'
                //         }},
                //     props: true,
                //     beforeEnter(to, from, next){
                //         condition = checkUserAccess('transactions', 'payable', 'create') && checkUserAccess('transactions', 'payable', 'view')
                //         if(!condition) next({name: 'Page404'})
                //         else next()
                //     },
                //     component: () => import("@/views/transactions/autocompute_vouchers/AccountsPayable.vue"),
                // },
                // {
                //     path: ':code',
                //     name: 'accountsPayableWithCalculation',
                //     meta: {
                //         title: (route) => {
                //             if(route.params.code === 'new') return 'New Payable'
                //             return 'Modify Payable'
                //         }},
                //     props: true,
                //     beforeEnter(to, from, next){
                //         condition = checkUserAccess('transactions', 'payable', 'create') && checkUserAccess('transactions', 'payable', 'view')
                //         if(!condition) next({name: 'Page404'})
                //         else next()
                //     },
                //     component: () => import("@/views/transactions/payable_receivable/AccountsPayable.vue"),
                // },
                /**
              {
                path: 'new',
                name: 'newAccountsPayableWithCalculation',
                meta: {title: 'New Payable'},
                beforeEnter(to, from, next){
                  condition = checkUserAccess('transactions', 'payable', 'create') && checkUserAccess('transactions', 'payable', 'view')
                  if(!condition) next({name: 'Page404'})
                  else next()
                },
                component: () => import("@/views/transactions/payable_receivable/NewAccountsPayableWithCalculations.vue"),
              },
              {
                path: ':code',
                name: 'updateAccountsPayableWithCalculation',
                meta: {title: 'Modify Payable'},
                props: true,
                beforeEnter(to, from, next){
                  condition = checkUserAccess('transactions', 'payable', 'create') && checkUserAccess('transactions', 'payable', 'view')
                  if(!condition) next({name: 'Page404'})
                  else next()
                },
                component: () => import("@/views/transactions/payable_receivable/UpdateAccountsPayableWithCalculations.vue"),
              },
                  **/
            ]
          },

          {
            path: 'prepaid-expenses',
            name: 'prepaidExpenses',
            redirect: {name: 'prepaidExpensesList'},
            meta: {title: 'Prepaid Expenses'},
            component: () => import('@/views/Filler.vue'),
            children: [
              {
                path: '',
                name: 'prepaidExpensesList',
                component: () => import('@/views/transactions/prepaid/PrepaidExpensesList.vue')
              },
              {
                path: 'new',
                name: 'prepaidExpensesNew',
                meta: {title: 'New Prepaid'},
                beforeEnter(to, from, next){
                  condition = checkUserAccess('transactions', 'prepaid', 'create') && checkUserAccess('transactions', 'prepaid', 'view')
                  if(!condition) next({name: 'Page404'})
                  else next()
                },
                component: () => import('@/views/transactions/prepaid/NewPrepaidExpense.vue')
              },
              {
                path: ':code',
                name: 'prepaidExpensesDetails',
                meta: {title: 'Modify Prepaid'},
                props: true,
                beforeEnter(to, from, next){
                  condition = checkUserAccess('transactions', 'prepaid', 'view')
                  if(!condition) next({name: 'Page404'})
                  else next()
                },
                component: () => import('@/views/transactions/prepaid/UpdatePrepaidExpense.vue')
              }
            ]
          },
          {
            path: 'cash-advances',
            name: 'cashAdvances',
            redirect: {name: 'cashAdvancesList'},
            meta: {title: 'Advances'},
            component: () => import('@/views/Filler.vue'),
            children: [
              {
                path: '',
                name: 'cashAdvancesList',
                component: () => import('@/views/transactions/advances/CashAdvancesList.vue')
              },
              {
                path: 'new',
                name: 'cashAdvancesNew',
                meta: {title: 'New Advances'},
                beforeEnter(to, from, next){
                  condition = checkUserAccess('transactions', 'advances', 'create') && checkUserAccess('transactions', 'advances', 'view')
                  if(!condition) next({name: 'Page404'})
                  else next()
                },
                component: () => import('@/views/transactions/advances_updated/NewUpdatedCashAdvance.vue')
              },
              {
                path: ':code',
                props: true,
                name: 'cashAdvancesDetails',
                meta: {title: 'Modify Advances'},
                beforeEnter(to, from, next){
                  condition = checkUserAccess('transactions', 'advances', 'view')
                  if(!condition) next({name: 'Page404'})
                  else next()
                },
                component: () => import('@/views/transactions/advances_updated/UpdatedCashAdvanceDetails.vue')
              }
            ]
          },
          {
            path: 'liquidation',
            name: 'cashAdvancesMainLiquidation',
            redirect: {name: 'liquidationList'},
            meta: {title: 'Liquidation'},
            component: () => import('@/views/Filler.vue'),
            children: [
              {
                path: '',
                name: 'liquidationList',
                component: () => import('@/views/transactions/advances_updated/MainLiquidationList.vue')
              },
              {
                path: 'new',
                name: 'newLiquidation',
                meta: {title: 'New Liquidation'},
                beforeEnter(to, from, next){
                  condition = checkUserAccess('transactions', 'liquidation', 'create') && checkUserAccess('transactions', 'liquidation', 'view')
                  if(!condition) next({name: 'Page404'})
                  else next()
                },
                component: () => import('@/views/transactions/advances_updated/NewMainLiquidation.vue')
              },
              {
                path: ':code',
                props: true,
                name: 'updateLiquidation',
                meta: {title: 'Modify Liquidation'},
                beforeEnter(to, from, next){
                  condition = checkUserAccess('transactions', 'liquidation', 'view')
                  if(!condition) next({name: 'Page404'})
                  else next()
                },
                component: () => import('@/views/transactions/advances_updated/UpdateMainLiquidation.vue')
              }
            ]
          },
          {
            path: 'transaction-disbursement',
            name: 'automatedDisbursement',
            redirect: {name: 'automatedDisbursementList'},
            component: () => import('@/views/Filler.vue'),
            children: [
              {
                path: '',
                name: 'automatedDisbursementList',
                component: () => import('@/views/transactions/automated_disbursement/AutomatedDisbursementList.vue')
              },
              {
                path: 'new',
                name: 'newAutomatedDisbursement',
                component: () => import('@/views/transactions/automated_disbursement/NewAutomatedDisbursement.vue')
              },
              {
                path: ':code',
                props: true,
                name: 'updateAutomatedDisbursement',
                component: () => import('@/views/transactions/automated_disbursement/UpdateAutomatedDisbursement.vue')
              }
            ]
          },
          {
            path: 'statement-of-activities',
            name: 'statementOfAccounts',
            redirect: {name: 'SOAPayablesListing'},
            component: () => import('@/views/Filler.vue'),
            children: [
              {
                path: 'statement-of-accounts-payables',
                name: 'SOAPayablesListing',
                redirect: {name: 'SOAPayableList'},
                children: [
                  {
                    path:'',
                    name: 'SOAPayableList',
                    component: () => import('../views/transactions/soa/StatementOfActivities.vue'),
                  },
                  {
                    path:'new',
                    name: 'SOAPayableNew',
                    component: () => import('@/views/transactions/soa/SOAPayableNew.vue')
                  },
                  {
                    path:':code',
                    props: true,
                    name: 'SOAPayableDetails',
                    component: () => import('@/views/transactions/soa/SOAPayableDetails.vue')
                  }
                ]
              },
              {
                path: 'statement-of-accounts-generation',
                name: 'SOASubconsListing',
                redirect: {name: 'SOASubconList'},
                children: [
                  {
                    path:'',
                    name: 'SOASubconList',
                    component: () => import('../views/transactions/soa/SOASubconListing.vue'),
                  },
                  {
                    path:'new',
                    name: 'SOAGeneration',
                    component: () => import('@/views/transactions/soa/SOAGenerationPage.vue')
                  },
                  {
                    path:':recipient',
                    props: true,
                    name: 'SOASubconDetails',
                    component: () => import('@/views/transactions/soa/SubconTransactionsDetailPage.vue')
                  },
                  {
                    path:':recipient/:code',
                    props: true,
                    name: 'SOADetails',
                    component: () => import('@/views/transactions/soa/SOADetailPage.vue')
                  },
                ]
              },
            ]
          },
          {
            path: "bank-reconciliations",
            name: "bankReconFiller",
            redirect: to => ({name: "bankReconList"}),
            component: () => import("@/views/Filler.vue"),
            children: [
              {
                path: "list",
                name: "bankReconList",
                meta: {title: 'Bank Reconciliation'},
                component: () => import("@/views/transactions/reconciliation/BankReconciling.vue")
              },
              {
                path: "create",
                name: "addBankRecon",
                component: () => import ("@/views/transactions/reconciliation/BankReconciliationPage.vue")
              }
            ]
          },
          {
            path: "request-for-payment",
            name: "requestForPaymentPage",
            redirect: to => ({name: "requestForPayment"}),
            component: () => import("@/views/Filler.vue"),
            children: [
              {
                path: "",
                meta: {title: 'Request for Payment'},
                name: "requestForPayment",
                component: () => import("@/views/transactions/rfp/RequestForPaymentList.vue")
              },
              {
                path: ":code",
                name: "requestForPaymentDetails",
                meta: {title: 'Modify Request for Payment'},
                props: true,
                component: () => import ("@/views/transactions/rfp/RequestForPaymentDetails.vue")
              }
            ]
          },
          {
            path: 'taxes',
            name: 'taxesModule',
            redirect: {name: 'VATTaxesModule'},
            component: () => import("@/views/Filler.vue"),
            children: [
              {
                path: "value-added-taxes",
                name: "VATTaxesModule",
                redirect: to => ({name: "VATTaxesModuleListing"}),
                component: () => import("@/views/Filler.vue"),
                children: [
                  {
                    path: "",
                    name: "VATTaxesModuleListing",
                    component: () => import("@/views/transactions/taxes/VATModule.vue")
                  },
                  {
                    path: "new-taxes-payable",
                    name: "NewVATModulePayable",
                    component: () => import("@/views/transactions/taxes/NewVATPayable.vue")
                  },
                  {
                    path: ":code",
                    name: "UpdateVATModulePayable",
                    props: true,
                    component: () => import("@/views/transactions/taxes/UpdateVATPayable.vue")
                  }
                ]
              },
              {
                path: "withholding-taxes",
                name: "withholdingTaxesModule",
                redirect: to => ({name: "withHoldingTaxList"}),
                component: () => import("@/views/Filler.vue"),
                children: [
                  {
                    path: "list",
                    name: "withHoldingTaxList",
                    component: () => import("@/views/transactions/taxes/WithholdingTaxModule.vue")
                  },
                ]
              },
            ]
          },
          {
            path: 'transaction-postings',
            name: 'transactionPostingFiller',
            meta: {title: 'Account Posting'},
            component: () => import('../views/Filler.vue'),
            redirect: to => ({name: "transactionPostingList"}),
            children: [
              {
                path: "list",
                name: "transactionPostingList",
                component: () => import("@/views/transactions/TransactionPostingList.vue")
              },
              {
                path: "create",
                name: "addTransactionPosting",
                component: () => import ("@/views/transactions/TransactionPostingPage.vue")
              }
            ]
          },
          {
            path: 'edit-particulars',
            name: 'editParticularsFiller',
            redirect: to => ({name: "editParticularsList"}),
            component: () => import('../views/Filler.vue'),
            children: [
              {
                path: "list",
                name: "editParticularsList",
                component: () => import("@/views/transactions/EditParticularsList.vue")
              },
              {
                path: "create",
                name: "editParticularForm",
                component: () => import ("@/views/transactions/EditParticularsPage.vue")
              }
            ]
          }
        ]
      },
      {
        path: '/monitoring',
        name: 'monitoring',
        meta: {requiresAccess: true},
        component: () => import('../views/management/ManagementPage.vue'),
        redirect: {name: 'accountsPayableFiller'},
        children: [
          {
            path: 'fix-asset-and-inventories',
            name: 'fixAssetsAndInventoryFiller',
            redirect: {name: 'fixAssetsAndInventoryList'},
            component: () => import('../views/Filler.vue'),
            children: [
              {
                path: 'list',
                name: 'fixAssetsAndInventoryList',
                component: () => import('../views/management/FixedAssetsInventoryPage.vue')
              },
              {
                path: "create",
                name: "fixAssetsAndInventoryForm",
                component: () => import("@/components/forms/FixAssetsAndInventoryForm.vue")
              },
              {
                path: ":id",
                name: 'editAssetAndInventoryDetails',
                props: true,
                component: () => import('@/components/details/FixAssetsAndInventoryDetails.vue')
              },
            ]
          },
          {
            path: 'accounts-payable',
            name: 'accountsPayableFiller',
            redirect: to => ({name: "accountsPayableList"}),
            component: () => import('../views/Filler.vue'),
            children: [
              {
                path: "list",
                name: 'accountsPayableList',
                component: () => import('@/views/management/AccountsPayablePage.vue')
              },
              {
                path: ":id",
                name: 'accountsPayableDetails',
                props: true,
                component: () => import('@/components/details/AccountsPayableDetails.vue')
              },
            ]
          },
          {
            path: '/accounts-receivable',
            name: 'accountsReceivableFiller',
            component: () => import('../views/Filler.vue'),
            children: [
              {
                path: "list",
                name: 'accountsReceivableList',
                component: () => import('../views/management/AccountsReceivablePage.vue')
              },
              {
                path: ":id",
                name: "accountsReceivableDetails",
                props: true,
                component: () => import("@/components/details/AccountsReceivableDetails.vue")
              }
            ]
          },
          {
            path: 'cheque-monitoring',
            name: 'chequeMonitoring',
            meta: {title: 'Cheque Monitoring'},
            component: () => import('../views/management/chequeMonitoring/ChequeMonitoring.vue'),
          },
        ]
      },
      {
        path: '/reports',
        name: 'reports',
        meta: {requiresAccess: true},
        component: () => import('../views/reports/ReportsPage.vue'),
        redirect: {name: 'journalSummary'},
        children: [
          {
            path: 'transaction-reports',
            name: 'transactionsReport',
            component: () => import('../views/reports/ReportsTransactionsPage.vue'),
            redirect: {name: 'cashCheckVoucherReport'},
            children: [
              {
                path: 'cash-check-voucher-report',
                name: 'cashCheckVoucherReport',
                component: () => import('../views/reports/CashCheckVoucherReportPage.vue')
              },
              {
                path: 'payment-receipts-voucher-report',
                name: 'paymentReceiptsVoucherReport',
                component: () => import('../views/reports/PaymentReceiptsReportPage.vue')
              },
              {
                path: 'journal-voucher-report',
                name: 'journalVoucherReport',
                component: () => import('../views/reports/JournalVouchersReportPage.vue')
              }
            ]
          },
          {
            path: 'journal-summary',
            name: 'journalSummary',
            meta: {title: 'Journal Summary'},
            component: () => import('../views/reports/JournalSummary.vue')
          },
          {
            path: 'ledger-summary',
            name: 'ledgerSummary',
            meta: {title: 'Ledger Summary'},
            component: () => import('../views/reports/LedgerSummary.vue')
          },
          {
            path: 'trial-balance',
            name: 'trialBalance',
            meta: {title: 'Trial Balance'},
            component: () => import('../views/reports/TrialBalancePage.vue')
          },
          {
            path: 'financial-statements',
            name: 'financialStatements',
            component: () => import('../views/reports/FinancialStatementsPage.vue'),
            redirect: {name: 'balanceSheet'},
            children: [
              {
                path: 'balance-sheet',
                name: 'balanceSheet',
                meta: {title: 'Balance Sheet'},
                component: () => import('../views/reports/BalanceSheetPage.vue')
              },
              {
                path: "balance-sheet-compare",
                name: "balanceSheetCompare",
                meta: { title: "Balance Sheet Comparison" },
                component: () =>
                    import("../views/reports/BalanceSheetCompare.vue"),
              },
              {
                path: 'income-statement/:code?',
                name: 'incomeStatement',
                props: true,
                meta: {title: 'Income Statement'},
                //component: () => import('../views/reports/IncomeStatementPage.vue')
                component: () => import('../views/reports/income-statement/IncomeStatement.vue')
              }
            ]
          },
          {
            path: 'statement-of-accounts',
            name: 'statementOfAccountsReport',
            component: () => import('../views/reports/StatementOfAccountsPage.vue')
          },
          {
            path: 'account-details',
            name: 'accountDetails',
            component: () => import('../views/reports/AccountDetailsPage.vue')
          },
          {
            path: 'master-file',
            name: 'masterFile',
            redirect: {name: 'supplierSummary'},
            component: () => import('../views/reports/MasterFilePage.vue'),
            children: [
              {
                path: 'supplier-summary',
                name: 'supplierSummaryFiller',
                component: () => import('../views/Filler.vue'),
                children: [
                  {
                    path: '',
                    name: 'supplierSummary',
                    component: () => import('../views/reports/SupplierSummaryPage.vue')
                  },
                  {
                    path: ':code',
                    name: 'supplierTransactionDetail',
                    props: {header: 'Customer'},
                    component: () => import('../components/details/CustomerSupplierTransactionDetails.vue')
                  }
                ]
              },
              {
                path: 'customer-summary',
                name: 'customerSummaryFiller',
                component: () => import('../views/Filler.vue'),
                children: [
                  {
                    path: '',
                    name: 'customerSummary',
                    component: () => import('../views/reports/CustomerSummaryPage.vue')
                  },
                  {
                    path: ':code',
                    name: 'customerTransactionDetail',
                    props: {header: 'Customer'},
                    component: () => import('../components/details/CustomerSupplierTransactionDetails.vue')
                  }
                ]
              }
            ]
          },
          {
            path: 'budget-vs-actual',
            name: 'budgetVsActual',
            meta: {title: 'Budget vs Actual'},
            component: () => import('../views/reports/budgetvsactual/BudgetVsActual.vue')
          },
          {
            path: 'japan-account-conversion',
            name: 'japanAccountConversion',
            component: () => import('../views/reports/DivaConversionPage.vue')
          },
          {
            path: 'sales-ranking',
            name: 'salesRanking',
            meta: {title: 'Sales Ranking'},
            component: () => import('../views/reports/ranking/SalesRankingPage.vue')
          },
          {
            path: 'segment-ranking',
            name: 'segmentRanking',
            component: () => import('../views/reports/ranking/SegmentRankingPage.vue')
          },
          {
            path: 'client-ranking',
            name: 'clientRanking',
            component: () => import('../views/reports/ranking/ClientRankingPage.vue')
          },
          {
            path: 'cash-advances-summary',
            name: 'advancesSummary',
            meta: {title: 'Cash Advances Summary'},
            component: () => import('../views/reports/advances-summary/AdvancesSummary.vue')
          },
          {
            path: 'account-transactions/:code?',
            props: true,
            name: 'accountTransactions',
            meta: {title: 'Account Transactions'},
            component: () => import('../views/reports/account-transactions/AccountTransactions.vue')
          },
          {
            path: 'bank-transactions',
            name: 'bankTransactions',
            meta: {title: 'Bank Transactions'},
            component: () => import('../views/reports/account-transactions/BankTransactions.vue')
          },
            {
                path: 'aged-receivables',
                name: 'agedReceivables',
                component: () => import('@/views/reports/aged-receivables/AgedReceivables.vue')
            },
          {
                path: 'weekly-summary',
                name: 'weeklySummary',
                redirect: {name: 'weeklySummaryList'},
                children: [
                    {
                        path: '',
                        name: 'weeklySummaryList',
                        component: () => import('@/views/reports/invoice/WeeklySummaryPage.vue')
                    },
                ]
            },
          {
            path: 'custom-reports',
            name: 'customReports',
            meta: {title: 'Custom Reports'},
            component: () => import('../views/reports/custom-reports/CustomReports.vue')
          },
          {
            path: 'bir-report',
            name: 'BIR Report',
            redirect: {name: 'birReport'},
            children: [
              {
                path: '',
                name: 'birReport',
                component: () => import('@/views/reports/invoice/BirReportPage.vue')
              },
            ]
          },
        ]
      },
      {
        path: '/management',
        name: 'management',
        meta: {requiresAccess: true},
        component: () => import('../views/monitoring/MonitoringPage.vue'),
        redirect: {name: 'jobList'},
        children: [
          {
            path: 'vof-receiving',
            name: 'vofReceivingFiller',
            component: () => import('../views/Filler.vue'),
            redirect: to => ({name: "vofReceiving"}),
            children: [
              {
                path: "list",
                name: "vofReceiving",
                component: () => import("@/views/monitoring/vofReceivingPage.vue")
              },
              {
                path: ":transNo",
                name: "vofTransactionDetails",
                props: true,
                component: () => import("@/components/details/vofTransactionDetails.vue")
              }
            ]
          },
          {
            path: 'vof-adjustment',
            name: 'vofAdjustment',
            component: () => import('../views/monitoring/vofAdjustmentPage.vue')
          },
          {
            path: 'posting',
            name: 'posting',
            component: () => import('../views/monitoring/Posting.vue')
          },
          {
            path: 'job-list',
            name: 'jobList',
            component: () => import('../views/Filler.vue'),
            redirect: to => ({name: "jobListShipping"}),
            children: [
              {
                path: "shipping",
                name: "jobListShipping",
                meta: {title: 'Shipping Job Order'},
                component: () => import("@/views/monitoring/joblist-uploading/ShippingUpload.vue")
              },
              {
                path: "trucking",
                name: "jobListTrucking",
                meta: {title: 'Trucking Job Order'},
                props: true,
                component: () => import("@/views/monitoring/joblist-uploading/TruckingUpload.vue")
              }
            ]
          },
          {
            path: 'budget-management',
            name: 'budgetManagementFiller',
            redirect: {name: 'budgetManagement'},
            meta: {title: 'Budget Management'},
            component: () => import('../views/Filler.vue'),
            children: [
              {
                path: '',
                name: 'budgetManagement',
                component: () => import('../views/monitoring/budget/BudgetManagement.vue')
              },
              {
                path: 'new',
                name: 'newBudgetManagement',
                beforeEnter(to, from, next){
                  condition = checkUserAccess('management', 'budget_management', 'create') && checkUserAccess('management', 'budget_management', 'view')
                  if(!condition) next({name: 'Page404'})
                  else next()
                },
                component: () => import('../views/monitoring/budget/NewBudgetManagement.vue')
              }
            ]
          }
        ]
      },
      {
        path: 'setup',
        name: 'setup',
        meta: {requiresAccess: true},
        component: () => import('../views/SetupPage.vue'),
        redirect: {name: 'commonSetup'},
        children: [
          {
            path: 'system',
            name: 'systemSetup',
            component: () => import('../views/setup/system/SystemSetupPage.vue'),
            beforeEnter(to, from, next){
              condition = checkUserAccess('setup', 'system_setup', 'view')
              if(!condition) next({name: 'Page404'})
              else next()
            },
            redirect: {name: 'postingSettings'},
            children: [
              {
                path: 'posting-settings',
                name: 'postingSettings',
                component: () => import('../views/setup/system/PostingSettingsPage.vue'),
              },
              {
                path: 'administrative-settings',
                name: 'administrativeSettings',
                meta: {title: 'Administrative Settings'},
                component: () => import('../views/setup/system/AdministrativeSettingsPage.vue'),
              },
              {
                path: 'operation-settings',
                name: 'operationSettings',
                meta: {title: 'Operation Settings'},
                component: () => import('../views/setup/system/OperationSettingsPage.vue'),
              },
              {
                path: 'taxes',
                name: 'taxes',
                meta: {title: 'Taxes'},
                component: () => import('../views/setup/system/TaxesPage.vue'),
              },
              {
                path: 'business-types',
                name: 'businessTypes',
                meta: {title: 'Business Types'},
                component: () => import('../views/setup/system/BusinessTypesPage.vue'),
              },
              {
                path: 'payment-terms',
                name: 'paymentTerms',
                meta: {title: 'Payment Terms'},
                component: () => import('../views/setup/system/PaymentTerms.vue'),
              },
              {
                path: 'customer-group',
                name: 'customerGroup',
                meta: {title: 'Customer Groups'},
                component: () => import('../views/setup/system/CustomerGroupPage.vue'),
              },
              {
                path: 'billing-setup',
                name: 'billingSetup',
                meta: {title: 'Transactions Template'},
                component: () => import('../views/setup/system/SubDetailsBillingSetupPage.vue'),
              },
              {
                path: 'template-setup',
                name: 'templateSetup',
                meta: {title: 'Template Setup'},
                component: () => import('../views/setup/system/TemplateSetupPage.vue'),
              },
              {
                path: 'references-setup',
                name: 'transactionReferencesSetup',
                component: () => import('../views/setup/system/references/TransactionReferencesPage.vue'),
              }
            ]
          },
          {
            path: 'common',
            name: 'commonSetup',
            component: () => import('../views/setup/common/CommonSetupPage.vue'),
            redirect: {name: 'userProfileAndPolicies'},
            children: [
              {
                path: 'users',
                name: 'users',
                meta: {title: 'Users'},
                component: () => import('../views/Filler.vue'),
                beforeEnter(to, from, next){
                  condition = checkUserAccess('setup', 'user', 'view')
                  if(!condition) next({name: 'Page404'})
                  else next()
                },
                redirect: {name: 'usersList'},
                children: [
                  {
                    path: '',
                    name: 'usersList',
                    component: () => import('../views/setup/common/UsersPage.vue'),
                  },
                  {
                    path: ':code',
                    name: 'userUpdate',
                    props: true,
                    meta: {title: 'User Creation/Modification'},
                    component: () => import('../views/setup/common/UpdateUser.vue'),
                  }
                ]
              },
              {
                path: 'designations',
                name: 'userDesignations',
                component: () => import('../views/setup/common/designations/UserDepartmentPositions.vue'),
              },
              {
                path: 'access-and-restrictions',
                name: 'accessAndRestrictions',
                component: () => import('../views/setup/common/AccessAndRestrictionsPage.vue'),
              },
              {
                path: 'user-profile-and-policies',
                name: 'userProfileAndPolicies',
                meta: {title: 'Profile'},
                component: () => import('../views/setup/common/UserProfileAndPoliciesPage.vue'),
              },
              {
                path: 'overrides',
                name: 'overrides',
                component: () => import('../views/setup/common/OverridesPage.vue'),
              },
              {
                path: 'transaction-logs',
                name: 'transactionLogs',
                component: () => import('../views/setup/common/TransactionLogsPage.vue'),
              },
              {
                path: 'history-logs',
                name: 'historyLogs',
                component: () => import('../views/setup/common/HistoryLogsPage.vue'),
              },
              {
                path: 'email-and-notification',
                name: 'emailAndNotification',
                component: () => import('../views/setup/common/EmailAndNotificationPage.vue'),
              },
            ]
          },
          {
            path: 'accounting',
            name: 'accountingSetup',
            component: () => import('../views/setup/accounting/AccountingSetupPage.vue'),
            beforeEnter(to, from, next){
              condition = checkUserAccess('setup', 'accounting_setup', 'view')
              if(!condition) next({name: 'Page404'})
              else next()
            },
            redirect: {name: 'chartOfAccounts'},
            children: [
              {
                path: 'chart-of-accounts',
                name: 'chartOfAccounts',
                meta: {title: 'Chart of Accounts'},
                component: () => import('../views/setup/accounting/ChartOfAccountsPage.vue'),
              },
              {
                path: 'subsidiary-ledger',
                name: 'subsidiaryLedger',
                component: () => import('../views/setup/accounting/SubsidiaryLedgerPage.vue'),
              },
              {
                path: 'transaction-settings',
                name: 'transactionSettings',
                component: () => import('../views/Filler.vue'),
                redirect: {name: 'transactionSettingsList' },
                children: [
                  {
                    path: 'list',
                    name: 'transactionSettingsList',
                    component: () => import('../views/setup/accounting/TransactionSettingsPage.vue')
                  },
                  {
                    path: 'create',
                    name: 'transactionSettingsForm',
                    component: () => import('../views/setup/accounting/TransactionSettingsForm.vue'),
                  }
                ]
              },
              {
                path: 'budget',
                name: 'budget',
                component: () => import('../views/setup/accounting/BudgetPage.vue'),
              },
              {
                path: 'beginning-balances',
                name: 'beginningBalances',
                component: () => import('../views/setup/accounting/BeginningBalancesPage.vue'),
              },
              {
                path: 'account-mapping',
                name: 'accountMapping',
                meta: {title: 'Account Mapping'},
                component: () => import('../views/setup/accounting/SubsidiaryLedgerPage.vue'),
              },
              {
                path: 'subsidiary-tagging',
                name: 'subsidiaryTagging',
                meta: {title: 'Subsidiary Tagging'},
                component: () => import('../views/setup/accounting/SubsidiaryRelationshipPage.vue'),
              },
              {
                path: 'report-templates',
                name: 'reportTemplates',
                component: () => import('../views/setup/accounting/ReportTemplatesPage.vue'),
              },
            ]
          },
          {
            path: '/miscellaneous',
            name: 'miscellaneous',
            component: () => import('../views/setup/misc/MiscellaneousSetupPage.vue'),
            beforeEnter(to, from, next){
              condition = checkUserAccess('setup', 'miscellaneous', 'view')
              if(!condition) next({name: 'Page404'})
              else next()
            },
            redirect: {name: 'apiSetup'},
            children: [
              {
                path: 'api-setup',
                name: 'apiSetup',
                meta: {title: 'API Setup'},
                component: () => import('../views/setup/misc/ApiSetupPage.vue')
              },
              {
                path: 'company-setup',
                name: 'companySetup',
                meta: {title: 'Company Setup'},
                component: () => import('../views/setup/misc/CompanySetupPage.vue')
              },
              {
                path: 'financial-setup',
                name: 'financialSetup',
                meta: {title: 'Financial Setup'},
                component: () => import('../views/setup/misc/FinancialSetupPage.vue')
              }
            ]
          }
        ]
      },
      {
        path: '/entities',
        name: 'entities',
        meta: {requiresAccess: true},
        component: () => import('../views/Filler.vue'),
        redirect: to => {
          return {name: 'entity', params: {entity: "clients"}}
        },
        children: [
          {
            path: ':entity',
            name: 'entity',
            component: () => import('../views/entities/refactor/EntityPage.vue'),
            props: (route) => {
              if (route.params.entity !== 'suppliers' && route.params.entity !== 'customers' && route.params.entity !== 'subcontractors' && route.params.entity !== 'clients') {
                router.replace({name: "Page404"})
              }

              let header = "";

              if (route.params.entity === 'suppliers') {
                header = "Suppliers";
              } else if (route.params.entity === 'customers') {
                header = "Customers";
              }
              else if (route.params.entity === 'subcontractors') {
                header = "Subcontractors";
              }
              else if (route.params.entity === 'clients') {
                header = "Entity";
              }

              document.title = header + ' - Fujitrans'
              return {
                header: header,
              }
            },
          },
          {
            path: 'employees',
            name: 'employees',
            meta: {title: 'Employees'},
            component: () => import('../views/entities/EmployeeEntityPage.vue'),
            props: {header: 'Employees'}
          },
          {
            path: 'agents',
            name: 'agents',
            meta: {title: 'Agents'},
            component: () => import('../views/entities/AgentsEntityPage.vue'),
            props: {header: 'Agents'}
          },
          {
            path: 'purchasers',
            name: 'purchasers',
            meta: {title: 'Purchasers'},
            component: () => import('../views/entities/PurchasersEntityPage.vue'),
            props: {header: 'Purchasers'}
          },
        ],
      },
      {
        path: 'liquidation',
        name: 'branchLiquidation',
        meta: {requiresAccess: true, title: 'Liquidation'},
        redirect: {name: 'branchLiquidationList'},
        component: () => import('@/views/Filler.vue'),
        children: [
          {
            path: '',
            name: 'branchLiquidationList',
            component: () => import('@/views/transactions/advances/BranchLiquidation.vue')
          },
          // {
          //   path: 'new',
          //   name: 'newBranchLiquidation',
          //   meta: {title: 'New Liquidation'},
          //   beforeEnter(to, from, next){
          //     condition = checkUserAccess('branch_liquidation', 'all', 'create') && checkUserAccess('branch_liquidation', 'all', 'view')
          //     if(!condition) next({name: 'Page404'})
          //     else next()
          //   },
          //   component: () => import('@/views/transactions/advances/NewBranchLiquidation.vue')
          // },
          {
            path: ':code',
            props: true,
            name: 'branchLiquidationDetails',
            meta: {title: 'Modify Liquidation'},
            beforeEnter(to, from, next){
              condition = checkUserAccess('branch_liquidation', 'all', 'view')
              if(!condition) next({name: 'Page404'})
              else next()
            },
            component: () => import('@/views/transactions/requestor_liquidation/RequestorLiquidationDetails.vue')
          }
        ]
      },
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'Page404',
    component: NotFound
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from, next) => {
  const moduleState = useModuleStatesStore()

  if (to.meta.requiresAuth) {
    if (!localStorage.getItem(TOKEN) && to.name !== "login") return next({name: "login"})
    else if(to.meta.requiresAccess) {
      let module = to.matched[1].name

      if(to.matched[1].name === 'transactionsFiller') module = 'transactions'
      else if(to.matched[1].name === 'branchLiquidation') module = 'branch_liquidation'

      if(!moduleState.checkUserAccess(module)) {
        // returns module where user has access to redirect rather than dashboard
        let module = redirectToAccessibleModule()
        if(module) next({name: module})
        else {
          await logoutUser()
          await AlertConfigurations.failedAlert('You do not have the permissions to access this service.', 'Unauthorized')
        }
      } else next()
    }
    else return next()

    let expirationDate = Date.parse(localStorage.getItem("expirationLimit"));

    if (Date.now() > expirationDate) {
      localStorage.removeItem(TOKEN);
      localStorage.removeItem("authUser");
      localStorage.removeItem("expirationLimit");
      return next({name: "login"})
    }

  } else {
    if(localStorage.getItem(TOKEN) && to.name === 'login') {
      // returns module where user has access to redirect rather than dashboard
      let module = redirectToAccessibleModule()
      if(module) next({name: module})
      else {
        await logoutUser()
        await AlertConfigurations.failedAlert('You do not have the permissions to access this service.', 'Unauthorized')
      }
      // if(!moduleState.checkUserAccess('dashboard')) next({name: 'Page404'})
      // else next({name: 'dashboard'})
    } else {
      next()
    }
  }

  document.title = to.meta.title ? to.meta.title + ' - Fujitrans' : 'Fujitrans'
});

export default router
